"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZFeedbackScale = void 0;
const React = __importStar(require("react"));
const kendo_react_inputs_1 = require("@progress/kendo-react-inputs");
const styled_components_1 = __importDefault(require("styled-components"));
const RatingDiv = styled_components_1.default.div `
   width: 40px;
   height: 30px;
   transition: background-color 0.2s ease-in-out;
   text-align: center;
   border: ${props => `1px solid ${props.theme.green}`};
   background-color: ${props => props.selected || props.hovered ? props.theme.green : "transparent"};
`;
const CustomItem = (props) => {
    return (React.createElement(kendo_react_inputs_1.RatingItem, Object.assign({}, props, { style: { padding: 0 } }),
        React.createElement(RatingDiv, { selected: props.selected, hovered: props.hovered }, props.value)));
};
const ZFeedbackScaleComponent = (props) => {
    return (React.createElement("span", { className: props.className },
        React.createElement(kendo_react_inputs_1.Rating, Object.assign({ min: 1, max: 10 }, props, { item: CustomItem }))));
};
exports.ZFeedbackScale = styled_components_1.default(ZFeedbackScaleComponent) `
   & * {
      border-radius: 0;
   }
`;
//# sourceMappingURL=ZFeedbackScale.js.map